import React from "react";

const AttachmentEmptyState: React.FC<{ multiple?: boolean }> = ({ multiple = false }) => (
    <div className="flex items-center gap-2 rounded-lg border border-border-subtle bg-bg-base px-3 py-3 text-[10px] text-text-subtle">
        <svg
            aria-hidden="true"
            className="h-4 w-4 shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9Z" />
            <path d="M14 3v6h6M8 13h8M8 17h5" />
        </svg>
        <span>{multiple ? "No documents submitted" : "No document submitted"}</span>
    </div>
);

export default AttachmentEmptyState;
